import { render, staticRenderFns } from "./EventTrends.vue?vue&type=template&id=a9c88ff6&scoped=true"
import script from "./EventTrends.vue?vue&type=script&lang=js"
export * from "./EventTrends.vue?vue&type=script&lang=js"
import style0 from "./EventTrends.vue?vue&type=style&index=0&id=a9c88ff6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c88ff6",
  null
  
)

export default component.exports